import { Component } from '@angular/core';
import { BaseForm } from '@forms/base.form';

@Component({
    selector: 'app-t4-issue-form',
    templateUrl: './t4-issue.template.html',
})
export class T4IssueForm extends BaseForm {
    confirm1 = false;
    confirm2 = false;
    confirm3 = false;

    hasConfirmed(): boolean {
        return this.confirm1 && this.confirm2 && this.confirm3;
    }
}
